import {inject, Injectable} from '@angular/core';
import {MessageService} from 'primeng/api';
import {translate} from '@jsverse/transloco';

@Injectable({providedIn: 'root'})
export class ToastService {
  private messageService = inject(MessageService);

  showSuccess(summary: string, detail?: string, params?: Record<string, unknown>): Promise<void> {
    return this.show('success', summary, detail, params);
  }

  showSuccessMessage(): Promise<void> {
    return this.show(
      'success',
      'common.save.success.header',
      'common.save.success.detail',
      undefined,
    );
  }

  showError(summary: string, detail?: string, params?: Record<string, unknown>): Promise<void> {
    return this.show('error', summary, detail, params);
  }

  showWarning(summary: string, detail?: string, params?: Record<string, unknown>): Promise<void> {
    return this.show('warn', summary, detail, params);
  }

  private async show(
    severity: string,
    summary: string,
    detail?: string,
    params?: Record<string, unknown>,
  ): Promise<void> {
    const translatedSummary = params ? translate(summary, params) : translate(summary);
    const translatedDetail = detail ? (params ? translate(detail, params) : translate(detail)) : '';
    this.messageService.add({
      severity,
      summary: translatedSummary,
      detail: translatedDetail == detail ? '' : translatedDetail,
    });
  }
}
